import { format } from "date-fns";

export function formatMonth(date) {
  return format(date, "yyyy-MM");
}

export function formatScore(score) {
  return score.toLocaleString("ja-JP");
}
